import { render } from "./SalesSpecial.vue?vue&type=template&id=55ec89b3&lang=true"
import script from "./SalesSpecial.vue?vue&type=script&lang=js"
export * from "./SalesSpecial.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/ChatWidget/AssistantAi/StartUpIcons/SalesSpecial.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "55ec89b3"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('55ec89b3', __exports__)) {
    api.reload('55ec89b3', __exports__)
  }
  
  module.hot.accept("./SalesSpecial.vue?vue&type=template&id=55ec89b3&lang=true", () => {
    api.rerender('55ec89b3', render)
  })

}


export default __exports__